import React from 'react'
const LanguageContext = React.createContext({});
export const useTextResources =  ()=>{
    const context = React.useContext(LanguageContext)
    return key=>{
        if (context&&context.texts&&context.texts[key]) {
            return context.texts[key]
        } else {
            console.warn(`Resource not found for: ${key}`)
            return `[${key}]`
        }
    }
}
export const useMessageResources =  ()=>{
    const context = React.useContext(LanguageContext)
    return key=>{
        if (context&&context.messages&&context.messages[key]) {
            return context.messages[key]
        } else {
            console.warn(`Resource not found for: ${key}`)
            return `[${key}]`
        }
    }
}
export default LanguageContext;